export class RawDataResultModel {
  public allMedicinesInFileCount: number;
  public humanMedicinesCount: number;
  public veterinaryMedicinesCount: number;
  public insertedInRawDataCount: number;
  public insertedForUpdateCount: number;
  public authorisedMedicinesCount: number;
  public withdrawnMedicinesCount: number;
  public refusedMedicinesCount: number;
  public pendingMedicinesCount: number;
  public suspendedMedicinesCount: number;
  public transactionFailedCount: number;
}